import CommonState from '@/class/cargo/model/parameters/CommonState'

export function getCommonState(code, list) {
  for (var common of list) {
    if (common.code === code) {
      return common
    }
  }
  return null
}
export function getCommonCN(code, list) {
  for (const common of list) {
    if (common.chineseName === code) {
      return common
    }
  }
  return null
}

export const DEFAULT_STATU = new CommonState(-1, '-请选择-', 'empty')
export const INVOICE_FIRSTRANGE = new CommonState(0, '0-30天', 'Zero to Thirty Days')
export const INVOICE_SECONDRANGE = new CommonState(1, '30-60天', 'Thirty to Sixty Days')
export const INVOICE_THIRDRANGE = new CommonState(2, '60-90天', 'Sixty to Ninety Days')

/**
		 * 收付区间
		 */
export const INVOICE_INCOMECOSTRANGE = new Set([
  INVOICE_FIRSTRANGE,
  INVOICE_SECONDRANGE,
  INVOICE_THIRDRANGE
])

// ------------
// 发票种类
// ------------
export const INVOICE_CATEGORY_ELECTRONIC_INVOICE = new CommonState(1, '电子发票', 'ElectronicInvoice')
export const INVOICE_CATEGORY_PAPER_INVOICE = new CommonState(0, '纸质发票', 'PaperInvoice')
export const INVOICE_CATEGORY = new Set([
  INVOICE_CATEGORY_PAPER_INVOICE,
  INVOICE_CATEGORY_ELECTRONIC_INVOICE
])

// ------------
// 电子发票发送状态
// ------------
export const ELECTRONIC_INVOICE_SEND_STATUS_SENDED = new CommonState(1, '已发送', 'Sended')
export const ELECTRONIC_INVOICE_SEND_STATUS_NOT_SEND = new CommonState(0, '未发送', 'NotSend')
export const ELECTRONIC_INVOICE_SEND_STATUS = new Set([
  ELECTRONIC_INVOICE_SEND_STATUS_NOT_SEND,
  ELECTRONIC_INVOICE_SEND_STATUS_SENDED
])

// ------------
// 电子发票发送状态
// ------------
export const INVOICE_EXPORT_STATUS_EXPORTED = new CommonState(1, '已导出', 'Sended')
export const INVOICE_EXPORT_STATUS_NOT_EXPORTED = new CommonState(0, '未导出', 'NotSend')
export const INVOICE_EXPORT_STATUS = new Set([
  INVOICE_EXPORT_STATUS_EXPORTED,
  INVOICE_EXPORT_STATUS_NOT_EXPORTED
])

export const ALL = new CommonState(null, '全部', 'All')

// -------------
// 发票类型
// -------------

export const INVOICE_TYPE_NORMAL = new CommonState(0, '普通发票', 'Normal')
export const INVOICE_TYPE_DEDICATED = new CommonState(1, '专用发票', 'Dedicated')
export const INVOICE_TYPE_VAT = new CommonState(2, '增值税普通发票', 'VAT')
export const INVOICE_TYPE_VAT_DEDICATED = new CommonState(3, '增值税专用发票', 'VAT Dedicated')
export const INVOICE_TYPE_INTERNAL = new CommonState(4, '内部发票', 'Internal')
// export const INVOICE_TYPE_FCL = new CommonState(5, 'FCL标志', 'FCL') 这个是后端常量中有的 InvoiceType.java
export const INVOICE_TYPE_VAT_FEI = new CommonState(6, '电子发票（增值税专用发票）', 'Electronic invoice (VAT special invoice)')
export const INVOICE_TYPE_NORMAL_FEI = new CommonState(7, '电子发票（普通发票）', 'Electronic invoice (ordinary invoice)')

export const INVOICE_TYPES = [
  INVOICE_TYPE_VAT,
  INVOICE_TYPE_VAT_DEDICATED,
  INVOICE_TYPE_INTERNAL,
  INVOICE_TYPE_NORMAL,
  INVOICE_TYPE_DEDICATED
]

// 全电
export const INVOICE_TYPES_FEI = [
  INVOICE_TYPE_VAT_FEI,
  INVOICE_TYPE_NORMAL_FEI
]

export const INVOICE_TYPES_HAS_ALL = [
  ALL,
  INVOICE_TYPE_NORMAL,
  INVOICE_TYPE_DEDICATED,
  INVOICE_TYPE_VAT,
  INVOICE_TYPE_VAT_DEDICATED,
  INVOICE_TYPE_INTERNAL
]

// -------------
// 发票状态
// -------------

export const INVOICE_STATUS_NOTACQUIRED = new CommonState(0, '未领用', 'Not Acquired')
export const INVOICE_STATUS_ACQUIRED = new CommonState(1, '已领用', 'Acquired')
export const INVOICE_STATUS_USED = new CommonState(2, '已使用', 'Used')
export const INVOICE_STATUS_VOIDED = new CommonState(3, '已作废', 'Voided')
export const INVOICE_STATUS_WRITEBACK = new CommonState(4, '红冲', 'WriteBack')
export const INVOICE_STATUS_HAS_ALL = [
  ALL,
  INVOICE_STATUS_NOTACQUIRED,
  INVOICE_STATUS_ACQUIRED,
  INVOICE_STATUS_USED,
  INVOICE_STATUS_VOIDED,
  INVOICE_STATUS_WRITEBACK
]
export const INVOICE_STATUS = [
  INVOICE_STATUS_NOTACQUIRED,
  INVOICE_STATUS_ACQUIRED,
  INVOICE_STATUS_USED,
  INVOICE_STATUS_VOIDED,
  INVOICE_STATUS_WRITEBACK
]

/**
		 * 发票种类
		 */
export const MAKE_TYPE_PAPER = new CommonState(0, '纸质发票', 'Paper')
export const MAKE_TYPE_ELECTRONIC = new CommonState(1, '电子发票', 'Electronic')

export const MAKE_TYPES = new Set([
  ALL,
  MAKE_TYPE_PAPER,
  MAKE_TYPE_ELECTRONIC
])

/**
		 * 是否下载
		 */
export const IS_NOT_PRINTED = new CommonState(0, '未导出', 'IsNotPrinted')
export const IS_PRINTED = new CommonState(1, '已导出', 'IsPrinted')

export const PRINTED_TYPES = new Set([
  ALL,
  IS_NOT_PRINTED,
  IS_PRINTED

])

export const INVOICE_STATE_NOT_WRITEOFF = new CommonState(3, '未销账', 'Not Writeoff')
export const INVOICE_STATE_WRITEOFF = new CommonState(2, '已销账', 'Writeoff')

export const INVOICE_STATES_OPTIONS_HALF = new Set([
  ALL,
  INVOICE_STATE_NOT_WRITEOFF,
  INVOICE_STATE_WRITEOFF
])

export const INVOICE_STATE_NONE = new CommonState(0, '未开票', 'Not Invoice')
export const INVOICE_STATE_PARTIAL = new CommonState(1, '部分开票', 'Partial Invoice')
export const INVOICE_STATE_FULL = new CommonState(2, '全部开票', 'Full Invoice')

/**
		 * 开票状态
		 */
export const INVOICE_STATES = new Set([
  ALL,
  INVOICE_STATE_NONE,
  INVOICE_STATE_PARTIAL,
  INVOICE_STATE_FULL
])

/**
		 * 开票模式
		 */
export const INVOICE_PATTERN_JOB = 'job'
export const INVOICE_PATTERN_CHARGE = 'charge'
export const INVOICE_PATTERN_BILLING = 'billing'
export const INVOICE_PATTERN_BILLINGGROUP = 'billingGroup'
export const INVOICE_PATTERN_BILL_PAYMENT = 'billPayment'
export const INVOICE_PATTERN_INVOICE = 'invoice'

export const INVOICE_SINGLE = new CommonState(0, '单票开票', 'Single')
export const INVOICE_JOB = new CommonState(1, '合并开票', 'Merge')
export const INVOICE_HEDGE = new CommonState(2, '对冲开票', 'Hedge')

export const MERGE_TYPES = new Set([
  INVOICE_SINGLE,
  INVOICE_JOB,
  INVOICE_HEDGE
])

export const OFFSET_NORMAL = new CommonState(0, '未红冲', 'Normal')
export const OFFSET_BE_RED_PUNCH = new CommonState(1, '被红冲', 'Be Red Punch')
export const OFFSET_RED_PUNCH = new CommonState(2, '红冲', 'Red Punch')

export const OFFSET_STATES = new Set([
  OFFSET_NORMAL,
  OFFSET_BE_RED_PUNCH,
  OFFSET_RED_PUNCH
])

/**
		 * 外部开票接口类型
		 */
export const INTERFACE_AISINO = new CommonState('AISINO', '航天金税', 'Aisno')
export const INTERFACE_BAI_WANG = new CommonState('BAI_WANG', '百望税控', 'Bai Wang')

/**
		 * 支付类型 CARGO-7933
		 */
export const ACTUAL_AMOUNT_RECEIVABLES = new CommonState(1, '应收', 'Receivables')
export const ACTUAL_AMOUNT_PAYABLES = new CommonState(0, '应付', 'Payables')

/**
		 * 支付类型 CARGO-7933
		 */
export const ACTUAL_AMOUNT_STATES = new Set([
  ALL,
  ACTUAL_AMOUNT_RECEIVABLES,
  ACTUAL_AMOUNT_PAYABLES
])

export const INVOICE_RECEIVABLE = new CommonState(1, '应收发票', 'Invoice Receivable')
export const INVOICE_PAYABLE = new CommonState(0, '应付发票', 'Invoice Payable')

/**
 * 发票应收应付类型
 */
export const INVOICE_AR_STATES = new Set([
  INVOICE_RECEIVABLE,
  INVOICE_PAYABLE
])

/**
		 * 发票项目相关税率
		 */
export const INVOICE_GOODSNAME_TAX_RATE = new Set([
  new CommonState(0, ' ', ' '),
  new CommonState(1, '1%', 'One Percent'),
  new CommonState(3, '3%', 'Three Percent'),
  new CommonState(5, '5%', 'Five Percent'),
  new CommonState(6, '6%', 'Six Percent'),
  new CommonState(9, '9%', 'Nine Percent'),
  new CommonState(10, '10%', 'Ten Percent'),
  new CommonState(13, '13%', 'Thirteen Percent'),
  new CommonState(16, '16%', 'Sixteen Percent')
])
export const INVOICE_GOODS_NAME_TAX_RATE = new Set([
  new CommonState(0, ' ', ' '),
  new CommonState(-1, '不征税', 'Non taxation'),
  new CommonState(-2, '免税', 'Tax Free'),
  new CommonState(-3, '0%', 'Zero Percent'),
  new CommonState(1, '1%', 'One Percent'),
  new CommonState(3, '3%', 'Three Percent'),
  new CommonState(5, '5%', 'Five Percent'),
  new CommonState(6, '6%', 'Six Percent'),
  new CommonState(9, '9%', 'Nine Percent'),
  new CommonState(10, '10%', 'Ten Percent'),
  new CommonState(13, '13%', 'Thirteen Percent'),
  new CommonState(16, '16%', 'Sixteen Percent')
])

export const INVOICE_GOODS_NAME_TAX_RATE2 = new Set([
  new CommonState(0, '0%', ' '),
  new CommonState(1, '1%', 'One Percent'),
  new CommonState(3, '3%', 'Three Percent'),
  new CommonState(5, '5%', 'Five Percent'),
  new CommonState(6, '6%', 'Six Percent'),
  new CommonState(9, '9%', 'Nine Percent'),
  new CommonState(10, '10%', 'Ten Percent'),
  new CommonState(13, '13%', 'Thirteen Percent'),
  new CommonState(16, '16%', 'Sixteen Percent')
])

export const INVOICE_STATE_NONE_FINANCE = new CommonState(0, '未开票', 'Not Invoice')
export const INVOICE_STATE_FULL_FINANCE = new CommonState(2, '已开票', 'Full Invoice')

/**
 * 开票状态-财务综合查询使用
 */
export const INVOICE_STATES_FINANCE = [
  INVOICE_STATE_NONE_FINANCE,
  INVOICE_STATE_FULL_FINANCE
]

/**
 * 账单发票类型
 */
export const BILLING_INVOICE_TYPE_VAT = new CommonState('增值税普通发票', '增值税普通发票', 'Value Added Tax (VAT) General Invoice')
export const BILLING_INVOICE_TYPE_VAT_DEDICATED = new CommonState('增值税专用发票', '增值税专用发票', 'Value Added Tax (VAT) Special Invoice')
export const BILLING_INVOICE_TYPE_INTERNAL = new CommonState('内部发票', '内部发票', 'Internal Invoice')
export const BILLING_INVOICE_TYPES = [
  BILLING_INVOICE_TYPE_VAT,
  BILLING_INVOICE_TYPE_VAT_DEDICATED,
  BILLING_INVOICE_TYPE_INTERNAL
]
export const BILLING_INVOICE_TYPE_NOINVOICE = new CommonState('不开发票', '不开发票', 'No Invoice')
export const BILLING_INVOICE_TYPE_DEBITNOTE = new CommonState('DebitNote', 'Debit Note', 'Debit Note')
export const BILLING_INVOICE_TYPES_CJ = [
  BILLING_INVOICE_TYPE_VAT,
  BILLING_INVOICE_TYPE_VAT_DEDICATED,
  BILLING_INVOICE_TYPE_NOINVOICE,
  BILLING_INVOICE_TYPE_INTERNAL,
  BILLING_INVOICE_TYPE_DEBITNOTE
]

export const BILLING_INVOICE_TYPE_EI_VAT_DEDICATED = new CommonState('电子发票（增值税专用发票）', '电子发票（增值税专用发票）', 'Electronic invoices (special VAT invoices)')
export const BILLING_INVOICE_TYPE_EI_VAT = new CommonState('电子发票（普通发票）', '电子发票（普通发票）', 'Electronic Invoice (Free Life)')
export const BILLING_INVOICE_TYPES_EI = [
  BILLING_INVOICE_TYPE_VAT,
  BILLING_INVOICE_TYPE_VAT_DEDICATED,
  BILLING_INVOICE_TYPE_EI_VAT_DEDICATED,
  BILLING_INVOICE_TYPE_EI_VAT,
  BILLING_INVOICE_TYPE_INTERNAL
]

export const BILLING_INVOICE_TYPES_CJ_EI = [
  BILLING_INVOICE_TYPE_VAT,
  BILLING_INVOICE_TYPE_VAT_DEDICATED,
  BILLING_INVOICE_TYPE_EI_VAT_DEDICATED,
  BILLING_INVOICE_TYPE_EI_VAT,
  BILLING_INVOICE_TYPE_NOINVOICE,
  BILLING_INVOICE_TYPE_INTERNAL,
  BILLING_INVOICE_TYPE_DEBITNOTE
]
/**
 * 发票种类
 */
export const BILLING_INVOICE_CATEGORY_ELECTRONIC_INVOICE = new CommonState('电子发票', '电子发票', 'Electronic Invoice')
export const BILLING_INVOICE_CATEGORY_PAPER_INVOICE = new CommonState('纸质发票', '纸质发票', 'Paper Invoice')
export const BILLING_INVOICE_CATEGORY = [
  BILLING_INVOICE_CATEGORY_ELECTRONIC_INVOICE,
  BILLING_INVOICE_CATEGORY_PAPER_INVOICE
]

export const INVOICE_YSHS = 'YSHS' // 开票接口-云税慧商
export const INVOICE_TAX_EASY_THREE = 'TAX_EASY_THREE' // 开票接口-容津3.0
export const INVOICE_TAX_EASY_THREE_PLUS = 'TAX_EASY_THREE_PLUS' // 开票接口-容津全电
export const INVOICE_TAX_EASY = 'TAX_EASY' // 开票接口-容津
export const INVOICE_BWJSY = 'BWJSY' // 百旺金穗云
export const INVOICE_BAI_WANG_ORIGIN = 'BAI_WANG_ORIGIN' // 百旺标准版发票接口
export const INVOICE_HTXX = 'HTXX' // 航天信息-诺诺
export const INVOICE_NUONUO = 'NUONUO' // 诺诺全电
export const INVOICE_NUONUO_EI = 'NUONUO_EI' // 诺诺网电子发票
export const INVOICE_AISINO_EI = 'AISINO_EI' // 航信全电
export const INVOICE_AISINO_V2 = 'AISINO_V2' // 航天金税V2版本
export const INVOICE_EASY_INOIVCE_VIETNAM = 'EASY_INOIVCE_VIETNAM' // 杰贝越南税控

/**
 * 发票 电子发票发送邮箱状态
 */
export const EMAIL_STATUS_NOT_SEND = new CommonState(0, '未发送', 'Not Send')
export const EMAIL_STATUS_SEND = new CommonState(1, '已发送', 'Send')
export const INVOICE_EMAIL_STATUS = new Set([
  EMAIL_STATUS_NOT_SEND,
  EMAIL_STATUS_SEND
])

// -------------
// 特定约束类型
// -------------
export const SPECIFIC_CONSTRAINT_TYPE_NI = new CommonState('00', '正常发票', 'Normal Invoice')
export const SPECIFIC_CONSTRAINT_TYPE_CTS = new CommonState('04', '货物运输服务', 'Cargo transportation services')
export const SPECIFIC_CONSTRAINT_TYPES = [
  SPECIFIC_CONSTRAINT_TYPE_NI,
  SPECIFIC_CONSTRAINT_TYPE_CTS
]

/**
 * 货物运输服务明细
 */
export const RAILWAY = new CommonState('Railway', '铁路运输', 'Railway transportation')
export const ROAD = new CommonState('Road', '公路运输', 'Road transport')
export const WATER = new CommonState('Water', '水路运输', 'Water transportation')
export const AIR = new CommonState('Air', '航空运输', 'Air transport')
export const PIPELINE = new CommonState('Pipeline', '管道运输', 'Pipeline transportation')
export const INVOICE_CARGO_TRANSPORT = new Set([
  RAILWAY,
  ROAD,
  WATER,
  AIR,
  PIPELINE
])

/**
 * 红字申请状态
 */
export const RED_OFFSET_STATUS_NOT_APPLIED = new CommonState(0, '未申请', 'Not applied')
export const RED_OFFSET_STATUS_IN_APPLICATION = new CommonState(1, '申请中', 'In Application')
export const RED_OFFSET_STATUS_SUCCESS = new CommonState(2, '成功', 'success')
export const RED_OFFSET_STATUS_FAIL = new CommonState(3, '失败', 'fail')
// export const RED_OFFSET_STATUS_IN_REVOCATION = new CommonState(4, '撤销中', 'In revocation') // 这个状态作废不用了
// export const RED_OFFSET_STATUS_CANCEL = new CommonState(5, '撤销', 'cancel') // 这个状态作废不用了
export const RED_OFFSET_STATUS = [RED_OFFSET_STATUS_NOT_APPLIED, RED_OFFSET_STATUS_IN_APPLICATION, RED_OFFSET_STATUS_SUCCESS, RED_OFFSET_STATUS_FAIL]

/**
 * 红冲原因
 */
export const RED_OFFSET_REASON_01 = new CommonState('01', '开票有误', 'Incorrect invoicing')
export const RED_OFFSET_REASON_03 = new CommonState('03', '服务终止', 'Service Termination')
export const RED_OFFSET_REASON_04 = new CommonState('04', '销售折让', 'Sales Allowance')
export const RED_OFFSET_REASON_02 = new CommonState('02', '销货退回', 'Sales Return')
export const RED_OFFSET_REASON_INVOICE_ERROR = new CommonState('InvoiceError', '发票信息有误', 'Incorrect invoice information')
export const RED_OFFSET_REASON_CHARGE_ERROR = new CommonState('ChargeError', '费用信息有误', 'Incorrect charge information')
export const RED_OFFSET_REASONS = [RED_OFFSET_REASON_01, RED_OFFSET_REASON_03, RED_OFFSET_REASON_04]
export const RED_OFFSET_REASONS_NEW = [RED_OFFSET_REASON_01, RED_OFFSET_REASON_03, RED_OFFSET_REASON_04, RED_OFFSET_REASON_INVOICE_ERROR, RED_OFFSET_REASON_CHARGE_ERROR]
export const RED_OFFSET_REASON_ALL = [RED_OFFSET_REASON_01, RED_OFFSET_REASON_03, RED_OFFSET_REASON_04, RED_OFFSET_REASON_02, RED_OFFSET_REASON_INVOICE_ERROR, RED_OFFSET_REASON_CHARGE_ERROR]

/**
 * Payment Method: 杰贝越南税控
 */
export const PAYMENT_METHOD_TM = new CommonState('TM', 'Cash', 'Tiền mặt')
export const PAYMENT_METHOD_CK = new CommonState('CK', 'Payment transfer', 'Chuyển khoản')
export const PAYMENT_METHOD_TMCK = new CommonState('TMCK', 'Payment in cash or bank transfer', 'Tiền mặt/chuyển khoản')
export const PAYMENT_METHOD_TTD = new CommonState('TTD', 'Credit card payment', 'Đối trừ công nợ')
export const PAYMENT_METHOD_VIETNAM = [PAYMENT_METHOD_TM, PAYMENT_METHOD_CK, PAYMENT_METHOD_TMCK, PAYMENT_METHOD_TTD]

/**
 * Invoice Status: 杰贝越南税控
 */
export const INVOICE_STATUS_NONE = new CommonState(-1, 'not exist', 'not exist')
export const INVOICE_STATUS_0 = new CommonState(0, 'without digital signature', 'without digital signature')
export const INVOICE_STATUS_1 = new CommonState(1, 'have digital signature', 'have digital signature')
export const INVOICE_STATUS_2 = new CommonState(2, 'have declared tax', 'have declared tax')
export const INVOICE_STATUS_3 = new CommonState(3, 'replaced', 'replaced')
export const INVOICE_STATUS_4 = new CommonState(4, 'adjusted', 'adjusted')
export const INVOICE_STATUS_5 = new CommonState(5, 'canceled', 'canceled')
export const INVOICE_STATUS_6 = new CommonState(6, 'approved', 'approved')
export const INVOICE_STATUS_VIETNAM = [INVOICE_STATUS_NONE, INVOICE_STATUS_0, INVOICE_STATUS_1, INVOICE_STATUS_2, INVOICE_STATUS_3, INVOICE_STATUS_4, INVOICE_STATUS_5, INVOICE_STATUS_6]

/**
 * 发票性质/税率标识
 */
export const INVOICE_NATURE_NORMAL = new CommonState(0, '正常', 'Normal')
export const INVOICE_NATURE_NON_TAXABLE = new CommonState(1, '不征税', 'Non Taxable')
export const INVOICE_NATURE_TAX_FREE = new CommonState(2, '免税', 'Tax Free')
export const INVOICE_NATURE_NOT_CONFIRM = new CommonState(3, '不确定', 'Not Confirm')
export const INVOICE_NATURE = [INVOICE_NATURE_NORMAL, INVOICE_NATURE_TAX_FREE, INVOICE_NATURE_NON_TAXABLE]
// 列表使用
export const INVOICE_NATURE_LIST = [INVOICE_NATURE_NORMAL, INVOICE_NATURE_TAX_FREE, INVOICE_NATURE_NON_TAXABLE, INVOICE_NATURE_NOT_CONFIRM]
